import { CurrentUser } from '../../model/currrent-user';
import { UserRegistrationData } from '../../model/user';
import { UserProfileUpdatePasswordData } from '../../model/user-profile';
import { ForgetPasswordDto } from './reset-password.dto';

export class AuthApiMapper {
  static toResetPasswordDto(user: any): ForgetPasswordDto {
    return {
      redirectUrl: user.redirectUrl,
      email: user.email,
    };
  }

  static toChangePasswordDto(passwordType: UserProfileUpdatePasswordData) {
    return {
      oldPassword: passwordType.oldPassword,
      newPassword: passwordType.newPassword,
      confirmPassword: passwordType.confirmPassword,
    };
  }

  static toSignupUserDto(data: UserRegistrationData) {
    const { company, ...rest } = data;
    return {
      ...rest,
      companyName: data.company,
    };
  }
}
